import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from "axios";
import App from './components/App';
import { API_BASE_URL } from './config';
import './index.css';

// axios
axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
      <App />
  // </React.StrictMode>
);
